//import dependencies
import '../styles/output.css'
import '../styles/global.css'
import Card from './Card'
//
let Contacts=()=>{
    return(
        <>
        <div className='main px-2 py-3 bg-neutral-950 break-2:px-9'>
            <div>
              <h3 className='font-bold text-xl text-white py-1 underline decoration-yellow-400'>Get in Touch</h3>
            </div>
        <div className='flex flex-col justify-center items-center px-8 sm:flex-row sm:flex-wrap sm:justify-start'>
            {/* Email */}
            <Card title='Email' src='/images/icons/email-1-svgrepo-com.svg' className='flex-shrink-0'>
                <span> <a href='mailto:soweroy@gmail.com'>soweroy@gmail.com</a></span>
            </Card>
            {/* Phone */}
            <Card title='Phone' src='/images/icons/phone-svgrepo-com.svg' className='flex-shrink-0'>
                <span> <a href='tel:+254768841833'>0768841833</a></span>
            </Card>
            {/* Instagram */}
            <Card title='Instagram' src='/images/icons/instagram-svgrepo-com.svg' className='flex-shrink-0'>
                <span> <a href='https://www.instagram.com/royderell.png?igsh=MWdocDR6YzNjMHBmcQ=='>royderell.png</a></span>
            </Card>
            {/* Whatsapp icon by Jtblabs listed on SVG Repo   */}
            <Card title='Whatsapp' src='/images/icons/whatsapp-svgrepo-com.svg' className='flex-shrink-0'>
                <span> <a href='https://wa.me/254768841833'>0768841833</a></span>
            </Card>
        </div>
        </div>
        </>
    )
}
export default Contacts;